@if (isOpen) {
  <div
    class="notification-overlay g99-notification-overlay"
    aria-hidden="true"
    (click)="closed.emit()"
  ></div>

  <section
    class="notification-panel"
    role="dialog"
    aria-modal="true"
    aria-label="Notifications"
  >
    <header class="panel-header">
      <h3 class="title">Notifications</h3>
      @if (unreadCount > 0) {
        <div class="actions">
          <button class="link-btn" type="button" (click)="onMarkAllRead()"
            >Mark all as read</button
          >
          <g99-icon-btn
            [icon]="closeIcon"
            [height]="10"
            [width]="10"
            (click)="closed.emit()"
          />
        </div>
      }
    </header>

    <div class="tabs" aria-label="Notification filters">
      <lib-shared-tab
        [tabs]="notificationTabs"
        [activeTab]="activeNotificationTab"
        [routingMode]="'none'"
        [showAsTabOnMobile]="true"
        [equalWidthTabs]="false"
        (tabClick)="onSharedTabClick($event)"
      />
    </div>

    <div class="groups" (scroll)="onScroll($event)">
      <!-- ===== First-load skeleton (under the tabs) ===== -->
      @if (isLoadingNotifications() && groupedNotifications.length === 0) {
        <g99-lib-notification-skeleton [count]="5" [showMeta]="false" />
      } @else {
        <!-- ===== Real notifications ===== -->
        @if (allNotifications.length === 0) {
          <g99-lib-empty-notification-screen />
        } @else {
          <g99-lib-notification-list (navigated)="closed.emit()" />
          <!-- ===== Tail skeleton (while loading next page) ===== -->
          @if (isLoadingNotifications()) {
            <g99-lib-notification-skeleton [count]="3" [showMeta]="true" />
          }
        }
      }
    </div>
  </section>
}
